import styled from "styled-components";

const Title = styled.h2`
  margin-top: 0;
  margin-bottom: 0;
  overflow-wrap: break-word;
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: 3.2rem;
  font-weight: 600;
  line-height: 1.25em;
`;

export default Title;
